type Resolution = {
  screenResolutionHeight: number;
  screenResolutionWidth: number;
  windowResolutionHeight: number;
  windowResolutionWidth: number;
};

function getResolution(): Resolution {
  return {
    screenResolutionHeight: window.screen.height,
    screenResolutionWidth: window.screen.width,
    windowResolutionHeight: window.innerHeight,
    windowResolutionWidth: window.innerWidth
  };
}

export default getResolution;
